import { props } from '@ngrx/store';
import { createActionGroup, emptyProps } from '@ngrx/store';

import { Module } from '../models';

export const moduleActions = createActionGroup({
    source: 'Content Modules',
    events: {
        'Get Module': props<{ id: string }>(),
        'Get Module Success': props<{ module: Module }>(),
        'Get Module Error': props<{ id: string }>(),
        Clear: emptyProps(),
    },
});
